<template>
  <div class="w-full flex gap-12 bg-zinc-50 flex-wrap rounded-2xl overflow-clip items-center ">
    <div class="w-64 h-64 rounded-full overflow-clip ml-12">
      <GeneralImage
        :src="author.image"
        :alt="author.name"
        class="object-cover h-full w-full"
      />
    </div>

    <div class="flex flex-col flex-1 justify-center p-12 lg:pr-32">
      <p class="text-lg lg:text-2xl text-primary pb-6">
        {{ author.name }}
      </p>

      <Markdown
        v-if="author.bio"
        :md="author.bio"
      />
      <NuxtLink
        :to="author.linkedin"
        class="flex items-center mt-6 bg-white py-2 pr-6 pl-3 self-start hover:bg-primary-dark hover:text-primary duration-200 rounded-xl"
      ><Icon
        name="ri:linkedin-box-fill"
        class="text-2xl mr-2 text-primary"
      />Connect on <span class="font-bold ml-1">LinkedIn</span></NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ author: TeamMember }>()
</script>

<style scoped>

</style>
